interface Action {
    payload: any,
    type: string
}

const CaseReducer = (state = {}, action: Action) => {
    switch (action.type) {
        case 'CASE_SUBMIT':
            action.payload.created = true;
            return action.payload;
        case 'SINGLE_CASE':
            return action.payload;
        default:
            return state;
    }
};

export default CaseReducer;
